<template>
     <div class="modal fade text-left" id="appointmentModal" tabindex="3" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="appointmentModal">{{ $t("labels.selectedAppointment") }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  <form class="form">
                    <appointment-form :appointment="$store.state.currentAppointment" :is-new="false" ref="appointmentForm"></appointment-form>
                    <div class="form-actions">
                      <button type="button" class="btn btn-success" @click.prevent="updateAppointment($refs.appointmentForm.clonedAppointment)">
                      <i class="icon-note"></i> {{ $t("labels.save") }}
                      </button>
                      <button type="button" class="btn btn-warning" @click.prevent="deleteAppointment">
                          <i class="icon-note"></i> {{ $t("labels.delete") }}
                      </button>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeAppointmentModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppointmentForm from './AppointmentForm'
import AppointmentService from '@/services/appointment'
import Swal from 'sweetalert2'

export default {
    components: {
        AppointmentForm
    },
    data () {
        return {
            errors: []
        }
    },
    methods: {
        deleteAppointment: async function() {
          let self = this
          let currentAppointment = this.$store.state.currentAppointment
          let result;
          if (currentAppointment.shortId != null) {
            Swal.fire({
              title:  self.$t('labels.youAreModifyingPeriodicEvent'),
              text: self.$t('labels.continueModifyingPeriodicEvent'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#0CC27E',
              cancelButtonColor: '#FF586B',
              confirmButtonText: self.$t('labels.confirmModifiyingPeriodicEvent'),
              cancelButtonText: self.$t('labels.cancelModifiyingPeriodicEvent')
            }).then(async function (isConfirm) {
              if (isConfirm) {
                if (isConfirm.dismiss == 'backdrop')
                  return false
                if (isConfirm.dismiss == 'cancel')
                  result = await AppointmentService.delete(currentAppointment)
                if (isConfirm.value)  
                  result = await AppointmentService.deletePeriodic(currentAppointment)
                
                if (result) {
                  this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.appointment")]))
                  this.$emit('updateappointments')
                  this.$emit('deleteappointment', this.$store.state.currentAppointment)
                  this.$refs.closeAppointmentModal.click()
                    } else {
                    self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
                  }
              }
            }).catch(Swal.noop);
          }else {
            result = await AppointmentService.delete(currentAppointment)
            if (result) {
              this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.appointment")]))
              this.$emit('updateappointments')
              this.$emit('deleteappointment', this.$store.state.currentAppointment)
              this.$refs.closeAppointmentModal.click()
            } else {
              self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
            }
          }
           
        },
        updateAppointment: async function(updatedAppointment) {
            let self = this
            this.errors = []
            let currentAppointment = updatedAppointment
            if (!currentAppointment.startDate || !currentAppointment.endDate) {
                this.errors.push(this.$t("errors.dateRequired"))
            }
            if (currentAppointment.location.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.location")]))
            }
            if (currentAppointment.notifyBy.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyBy")]))
            }
            if (currentAppointment.notifyWhen.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyWhen")]))
            }
            if (this.errors.length === 0) {
                let result;
                if (currentAppointment.shortId != null) {
                  Swal.fire({
                    title:  self.$t('labels.youAreModifyingPeriodicEvent'),
                    text: self.$t('labels.continueModifyingPeriodicEvent'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#0CC27E',
                    cancelButtonColor: '#FF586B',
                    confirmButtonText: self.$t('labels.confirmModifiyingPeriodicEvent'),
                    cancelButtonText: self.$t('labels.cancelModifiyingPeriodicEvent')
                  }).then(async function (isConfirm) {
                    
                    if (isConfirm) {
                      if (isConfirm.dismiss == 'backdrop')
                        return false
                      if (isConfirm.dismiss == 'cancel')
                        result = await AppointmentService.update(currentAppointment)
                      if (isConfirm.value)  
                        result = await AppointmentService.updatePeriodic(currentAppointment)
                    }
                    if (result) {
                      self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.appointment")]))
                      self.$store.state.currentAppointment = {}
                      self.$emit('updateappointments')
                      self.$emit('updateappointment', currentAppointment)
                      self.$refs.closeAppointmentModal.click()
                    } else {
                      self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
                    }
                  }).catch(Swal.noop);
                }else {
                  result = await AppointmentService.update(currentAppointment)
                  if (result) {
                    self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.appointment")]))
                    self.$store.state.currentAppointment = {}
                    self.$emit('updateappointments')
                    self.$emit('updateappointment', currentAppointment)
                    self.$refs.closeAppointmentModal.click()
                  } else {
                    self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
                  }
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
        }
    }
}
</script>

